import { createFileRoute } from '@tanstack/react-router'

import {
  getFormOptions,
  listFormVersionsOptions,
} from '@/api/codegen/@tanstack/react-query.gen'

export const Route = createFileRoute(
  '/_auth/$companyId/spaces/$spaceId/projects/$projectId/forms/$formId',
)({
  loader: ({ context: { queryClient }, params: { projectId, formId } }) => {
    queryClient.ensureQueryData(
      getFormOptions({
        path: {
          projectID: projectId,
          formID: formId,
        },
        query: {
          expandRefs: true,
        },
      }),
    )

    queryClient.ensureQueryData(
      listFormVersionsOptions({
        path: {
          projectID: projectId,
          formID: formId,
        },
      }),
    )
  },
})
